var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoldBadge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 147,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "7.02%",
    y1: "25.71%",
    x2: "91.89%",
    y2: "75.28%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3BB3B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6962C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.6 13.65l49.79 28.17a5 5 0 0 1 2.53 4.35v56.17a5 5 0 0 1-2.53 4.35L78.6 134.86a5 5 0 0 1-4.92 0L23.9 106.7a5 5 0 0 1-2.54-4.35V46.17a5 5 0 0 1 2.54-4.35l49.78-28.17a5 5 0 0 1 4.92 0z",
    id: "b"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "2.7%",
    y: "-3.4%",
    width: "94.5%",
    height: "106.9%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-13.8%",
    y: "-14.3%",
    width: "127.6%",
    height: "128.6%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M43.63 56l-16.46 8.65 3.14-18.32L17 33.35l18.4-2.68L43.63 14l8.23 16.67 18.4 2.68-13.32 12.98 3.15 18.32z"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.3%",
    y: "-10.9%",
    width: "120.7%",
    height: "121.7%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.85 1.65l60.38 34.17a5 5 0 0 1 2.54 4.35v68.17a5 5 0 0 1-2.54 4.35l-60.38 34.17a5 5 0 0 1-4.93 0L13.54 112.7a5 5 0 0 1-2.54-4.35V40.17a5 5 0 0 1 2.54-4.35L73.92 1.65a5 5 0 0 1 4.93 0z",
    fill: "url(#a)",
    transform: "translate(-11 -1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFCF40",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)",
    transform: "translate(22 31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D7579",
    d: "M43.5 63.25L19.1 76.07l4.67-27.16L4.03 29.68 31.3 25.7 43.5 1l12.2 24.71 27.27 3.97L63.23 48.9l4.66 27.16z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FCCF40",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC73",
    d: "M43.5 1l.21 13.2-8.15 16.72-4.25-5.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5A71D",
    d: "M43.5 1l.22 13.26 8.14 16.41 3.9-4.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5A71D",
    d: "M82.95 29.67L70.3 33.36l-18.44-2.69 3.84-5zM4.04 29.67l13.02 3.72 18.67-2.63-4.22-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF40",
    d: "M4.02 29.66L17 33.35 30.3 46.32l-6.54 2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5A71D",
    d: "M82.97 29.66l-12.72 3.67-13.3 12.98 6.28 2.62zM19.11 76.07l8.05-11.42 16.52-8.7v7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4AF37",
    d: "M67.9 76.08l-7.8-11.43-16.5-8.7-.1 7.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5A71D",
    d: "M67.9 76.06l-7.81-11.41-3.15-18.34 6.3 2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF40",
    d: "M19.1 76.1l8.07-11.44 3.15-18.35-6.56 2.62z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoldBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gold-badge.d5d25ab23867df75bd6946b007394844.svg";